import { NAV_ITEMS, ORGANIZATION_NAME } from '../constants';
import { jumpToAnchor } from '../utils/anchor-navigation';

function Footer() {
  return (
    <footer className="border-t border-hub-forest/10 bg-hub-paper px-5 py-10">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 text-sm text-hub-muted md:flex-row md:items-center md:justify-between">
        <div>
          <p className="font-display text-2xl font-bold text-hub-forest">{ORGANIZATION_NAME}</p>
          <p className="mt-2 max-w-xl">Organized for charitable, educational, and community-centered purposes through inclusive local outreach.</p>
        </div>
        <nav className="flex flex-wrap gap-4 text-xs font-black uppercase tracking-[0.18em]" aria-label="Footer">
          {NAV_ITEMS.map((item) => (
            <a key={item.href} href={item.href} onClick={(event) => jumpToAnchor(event, item.href)} className="hover:text-hub-coral">
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
